var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import store from "../../reduxStore/store";
import { GetProductDataService, getLoggedInRepDetails } from "../../services/apiServices/salesRepDataService";
import { dataAddingOnCart, gettingCartData } from "../../reduxStore/actions/salesRepDataAction";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
import { isLoading } from "../../services/behaviorSubjectService";
import { COLLECTION_PAGE_SIZE, EDIT_ORDER_FLAG } from "../Constant";
import { useTranslation } from "react-i18next";
import { SharedFunctions, getDiscountTypeFromValueType } from "../SharedFunctions";
import { fetchAllProductsForCollections } from "../../reduxStore/actions/salesRepDataAction";
export function ProductTableUsingGraphQLBL() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var dispatch = useDispatch();
    var t = useTranslation().t; //* Translation *
    var debounce = SharedFunctions().debounce;
    var _v = getLoggedInRepDetails(), shopCurrency = _v.shopCurrency, currency = _v.currency;
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); });
    var selectFeatures = ((_a = salesRepData.baseData) === null || _a === void 0 ? void 0 : _a.select) ? (_b = salesRepData.baseData) === null || _b === void 0 ? void 0 : _b.select : {};
    var _w = useState(""), productSearchText = _w[0], setProductSearchText = _w[1];
    var _x = useState(false), searchTablePopupOpen = _x[0], setSearchTablePopupOpen = _x[1];
    var _y = useState(false), getProductsLoading = _y[0], setGetProductsLoading = _y[1];
    var _z = useState([]), productsArray = _z[0], setProductsArray = _z[1];
    var _0 = useState([]), selectedProductArray = _0[0], setSelectedProductArray = _0[1];
    var _1 = useState([]), selectedProductIdArray = _1[0], setSelectedProductIdArray = _1[1];
    var _2 = useState([]), selectedVariantArray = _2[0], setSelectedVariantArray = _2[1];
    var _3 = useState({}), netQuantitySubtotal = _3[0], setNetQuantitySubtotal = _3[1];
    var _4 = useState(0), totalOrderAmount = _4[0], setTotalOrderAmount = _4[1];
    var _5 = useState([]), finalSelectedProducts = _5[0], setFinalSelectedProducts = _5[1];
    var _6 = useState(false), uncheckedFlag = _6[0], setUncheckedFlag = _6[1];
    var _7 = useState(), pageInfo = _7[0], setPageInfo = _7[1];
    var _8 = useState(0), collectionProductsPageIndex = _8[0], setCollectionProductsPageIndex = _8[1];
    var propsFromCreateOrderParentTab = false;
    var _9 = useState((_c = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) !== null && _c !== void 0 ? _c : {}), editOrderReduxData = _9[0], setEditOrderReduxData = _9[1];
    var isEditOrder = ((_d = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _d === void 0 ? void 0 : _d.actionEvent) === EDIT_ORDER_FLAG;
    var isUpdatedCart = (_e = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _e === void 0 ? void 0 : _e.isUpdatedCart;
    var createOrderTabReduxState = (_f = useSelector(function () { return store.getState().salesRepData.createOrderTab; })) !== null && _f !== void 0 ? _f : {};
    var wholePriceObj = (_g = createOrderTabReduxState.wholePriceObj) !== null && _g !== void 0 ? _g : {}; // Pricelist
    var hideWholeSalePriceListColumn = !(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.PriceList) || (createOrderTabReduxState === null || createOrderTabReduxState === void 0 ? void 0 : createOrderTabReduxState.customerName) === "" || ((_h = Object.keys(wholePriceObj)) === null || _h === void 0 ? void 0 : _h.length) === 0;
    var _10 = useState({ msg: "", open: false, severity: "error" }), alertErrorMsg = _10[0], setAlertErrorMsg = _10[1];
    var _11 = useState({}), isQuantityError = _11[0], setIsQuantityError = _11[1];
    var storefrontAccessToken = (_j = store.getState().salesRepData.baseData) === null || _j === void 0 ? void 0 : _j.storefrontAccessToken;
    var collectionProductsData = useSelector(function () { var _a, _b; return (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.collectionProductsData) !== null && _b !== void 0 ? _b : []; });
    var isShowSpecificProducts = selectFeatures.featuresAdditionalSettings.showProducts === "showSpecific";
    var activeCollectionList = (_l = (_k = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.baseData) === null || _k === void 0 ? void 0 : _k.activeCollectionList) !== null && _l !== void 0 ? _l : [];
    var tableContainerRef = useRef(null);
    var _12 = useState({}), discount_idObject = _12[0], setDiscount_idObject = _12[1];
    var _13 = useState("percentage"), selectedDiscountType = _13[0], setSelectedDiscountType = _13[1];
    var _14 = useState({}), isDiscountError = _14[0], setIsDiscountError = _14[1];
    var _15 = useState(false), discountAlertBox = _15[0], setDiscountAlertBox = _15[1];
    var _16 = useState("percentage"), pendingDiscountType = _16[0], setPendingDiscountType = _16[1];
    var _17 = useState(false), isDiscountAppliedInInline = _17[0], setIsEditDraftOrderDiscount = _17[1];
    var ShopApplyDiscount = ((_m = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.featuresAdditionalSettings) === null || _m === void 0 ? void 0 : _m.showApplyDiscount) ? (_o = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.featuresAdditionalSettings) === null || _o === void 0 ? void 0 : _o.showApplyDiscount : false;
    // Keep these strictly boolean. Some shops return applied_discount.value as "0.00" (string),
    // which would otherwise flow to the server as a string and break boolean parsing.
    var appliedDiscountValue = (_q = (_p = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _p === void 0 ? void 0 : _p.applied_discount) === null || _q === void 0 ? void 0 : _q.value;
    var isDiscoutAppiedInSubTotal = Number(appliedDiscountValue !== null && appliedDiscountValue !== void 0 ? appliedDiscountValue : 0) > 0;
    var isDiscoutAppliedInEditDraft = Boolean(isDiscountAppliedInInline) || Boolean(isDiscoutAppiedInSubTotal);
    var _18 = useState(0), masterSubTotal = _18[0], setMasterSubTotal = _18[1];
    var _19 = useState(false), isRemoveCartPopup = _19[0], setIsRemoveCartPopup = _19[1];
    var _20 = useState(null), hoveredIconIndex = _20[0], setHoveredIconIndex = _20[1];
    var _21 = useState(false), loadMoreProducts = _21[0], setLoadMoreProducts = _21[1];
    // --- Custom line items ---
    var CUSTOM_VARIANT_PREFIX = "custom:";
    var isCustomVariantId = function (variantId) { return typeof variantId === "string" && variantId.startsWith(CUSTOM_VARIANT_PREFIX); };
    var isCustomVariant = function (variant) { return (variant === null || variant === void 0 ? void 0 : variant.custom) === true || (variant === null || variant === void 0 ? void 0 : variant.isCustom) === true || isCustomVariantId(variant === null || variant === void 0 ? void 0 : variant.variantId); };
    // Modal state for custom items (kept in BL to follow code pattern)
    var _22 = useState(false), customItemModalOpen = _22[0], setCustomItemModalOpen = _22[1];
    var _23 = useState("add"), customItemModalMode = _23[0], setCustomItemModalMode = _23[1];
    var _24 = useState({}), customItemInitial = _24[0], setCustomItemInitial = _24[1];
    // Client-side pagination for specific collections: show 250 per page, arrows slice the loaded list
    var filterCollectionBySearch = function (list, searchValue) {
        var _a, _b, _c;
        var words = (_b = (_a = searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.split(" ");
        if (!(words === null || words === void 0 ? void 0 : words.length))
            return list !== null && list !== void 0 ? list : [];
        return (_c = (list && list.filter(function (product) {
            var _a, _b, _c;
            var title = ((_a = product === null || product === void 0 ? void 0 : product.title) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
            var handle = ((_b = product === null || product === void 0 ? void 0 : product.handle) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || "";
            var matchTitle = words.every(function (w) { return title === null || title === void 0 ? void 0 : title.includes(w); });
            var matchHandle = words.every(function (w) { return handle === null || handle === void 0 ? void 0 : handle.includes(w); });
            var matchVariant = (_c = product === null || product === void 0 ? void 0 : product.variants) === null || _c === void 0 ? void 0 : _c.some(function (v) {
                return words.every(function (w) { var _a, _b, _c, _d; return ((_b = (_a = v === null || v === void 0 ? void 0 : v.title) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(w)) || ((_d = (_c = v === null || v === void 0 ? void 0 : v.sku) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === null || _d === void 0 ? void 0 : _d.includes(w)); });
            });
            return matchTitle || matchHandle || matchVariant;
        }))) !== null && _c !== void 0 ? _c : [];
    };
    // Memoize so we don't re-filter the full list on every Prev/Next click
    var listToPaginate = useMemo(function () { return ((productSearchText === null || productSearchText === void 0 ? void 0 : productSearchText.trim()) ? filterCollectionBySearch(collectionProductsData, productSearchText) : collectionProductsData !== null && collectionProductsData !== void 0 ? collectionProductsData : []); }, [collectionProductsData, productSearchText]);
    var getListToPaginate = function () { return listToPaginate; };
    var applyCollectionPage = function (list, pageIndex) {
        setCollectionProductsPageIndex(pageIndex);
        setProductsArray(list.slice(pageIndex * COLLECTION_PAGE_SIZE, (pageIndex + 1) * COLLECTION_PAGE_SIZE));
        setPageInfo({
            hasNextPage: list.length > (pageIndex + 1) * COLLECTION_PAGE_SIZE,
            hasPreviousPage: pageIndex > 0,
        });
    };
    var customVariantById = useMemo(function () {
        var _a;
        var map = new Map();
        (_a = (selectedVariantArray !== null && selectedVariantArray !== void 0 ? selectedVariantArray : [])) === null || _a === void 0 ? void 0 : _a.forEach(function (v) {
            var _a;
            var id = (_a = v === null || v === void 0 ? void 0 : v.customLineItemId) !== null && _a !== void 0 ? _a : (typeof (v === null || v === void 0 ? void 0 : v.variantId) === "string" && v.variantId.startsWith(CUSTOM_VARIANT_PREFIX) ? v.variantId.replace(CUSTOM_VARIANT_PREFIX, "") : "");
            if (id)
                map.set(id, v);
        });
        return map;
    }, [selectedVariantArray]);
    var newCustomLineItemId = function () {
        var _a;
        try {
            // @ts-ignore - crypto may not be typed depending on TS lib target
            if ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.crypto) === null || _a === void 0 ? void 0 : _a.randomUUID) {
                // @ts-ignore
                return globalThis.crypto.randomUUID();
            }
        }
        catch (_b) { }
        return "cli_".concat(Date.now(), "_").concat(Math.random().toString(16).slice(2));
    };
    var openAddCustomItemModal = function () {
        setCustomItemModalMode("add");
        setCustomItemInitial({});
        setCustomItemModalOpen(true);
    };
    var openEditCustomItemModal = function (customLineItemId) {
        var _a, _b, _c, _d, _e, _f;
        if (!customLineItemId)
            return;
        var v = customVariantById.get(customLineItemId);
        if (!v)
            return;
        var isPhysical = !!((_a = v === null || v === void 0 ? void 0 : v.isPhysicalProduct) !== null && _a !== void 0 ? _a : v === null || v === void 0 ? void 0 : v.requires_shipping);
        // Use weight and weight_unit directly from backend (no conversion from grams)
        var weight = "";
        var weight_unit = "kg";
        if (isPhysical && (v === null || v === void 0 ? void 0 : v.weight) !== undefined && (v === null || v === void 0 ? void 0 : v.weight) !== null && (v === null || v === void 0 ? void 0 : v.weight) > 0 && (v === null || v === void 0 ? void 0 : v.weight_unit)) {
            // Use weight and weight_unit directly from backend response
            weight = v.weight.toString();
            weight_unit = v.weight_unit;
        }
        // If weight/unit not available, leave empty (no fallback conversion)
        setCustomItemModalMode("edit");
        setCustomItemInitial({
            customLineItemId: customLineItemId,
            title: ((_c = (_b = v === null || v === void 0 ? void 0 : v.name) !== null && _b !== void 0 ? _b : v === null || v === void 0 ? void 0 : v.title) !== null && _c !== void 0 ? _c : "").toString() || "",
            price: ((_d = v === null || v === void 0 ? void 0 : v.price) !== null && _d !== void 0 ? _d : (Number((_e = v === null || v === void 0 ? void 0 : v.variantPrice) !== null && _e !== void 0 ? _e : 0) || 0).toFixed(2)).toString(),
            quantity: Math.max(1, Number((_f = v === null || v === void 0 ? void 0 : v.quantity) !== null && _f !== void 0 ? _f : 1) || 1),
            taxable: v === null || v === void 0 ? void 0 : v.taxable,
            isPhysicalProduct: isPhysical,
            weight: weight,
            weight_unit: weight_unit,
        });
        setCustomItemModalOpen(true);
    };
    var closeCustomItemModal = function () { return setCustomItemModalOpen(false); };
    // Conversion functions moved to SharedFunctions.tsx for reuse
    var parseCustomLineItemWeight = function (li) {
        var _a;
        try {
            // Read weight and weight_unit from backend response
            var weight = (li === null || li === void 0 ? void 0 : li.weight) !== undefined && (li === null || li === void 0 ? void 0 : li.weight) !== null ? Number(li === null || li === void 0 ? void 0 : li.weight) : undefined;
            var weight_unit = ((_a = li === null || li === void 0 ? void 0 : li.weight_unit) !== null && _a !== void 0 ? _a : "").toString().trim() || undefined;
            // Validate weight_unit is one of the allowed values
            var validUnits = ["kg", "g", "lb", "oz"];
            var validWeightUnit = weight_unit && validUnits.includes(weight_unit.toLowerCase()) ? weight_unit.toLowerCase() : undefined;
            return {
                weight: weight !== undefined && weight > 0 ? weight : undefined,
                weight_unit: validWeightUnit,
            };
        }
        catch (error) {
            // Return safe defaults on error
            return { weight: undefined, weight_unit: undefined };
        }
    };
    //Update Cart or Cart.json
    var productAddOnCart = function (params, Type, updateVariants) { return __awaiter(_this, void 0, void 0, function () {
        var variantsAndQuantityArray, _a, response_GetCart, variantIdsArray, variantIdsSetArray_1, variant_Id, CartErrorRespose, error_1;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _a = Type;
                    switch (_a) {
                        case "add.js": return [3 /*break*/, 1];
                        case "update.js": return [3 /*break*/, 3];
                        case "change.js": return [3 /*break*/, 4];
                        case "clear.js": return [3 /*break*/, 5];
                    }
                    return [3 /*break*/, 6];
                case 1: return [4 /*yield*/, dispatch(gettingCartData())];
                case 2:
                    response_GetCart = _h.sent();
                    variantIdsArray = (_c = (_b = response_GetCart === null || response_GetCart === void 0 ? void 0 : response_GetCart.data) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.map(function (item) { return item === null || item === void 0 ? void 0 : item.variant_id; });
                    variantIdsSetArray_1 = new Set(variantIdsArray);
                    variantsAndQuantityArray = params === null || params === void 0 ? void 0 : params.reduce(function (acc, item) {
                        var _a;
                        // Skip custom line items - they cannot be added to Shopify cart.js
                        if (isCustomVariant(item)) {
                            return acc;
                        }
                        var variantId = Number((_a = item === null || item === void 0 ? void 0 : item.variantId) === null || _a === void 0 ? void 0 : _a.split("gid://shopify/ProductVariant/")[1]);
                        if (!Number.isFinite(variantId)) {
                            return acc;
                        }
                        if (!(variantIdsSetArray_1 === null || variantIdsSetArray_1 === void 0 ? void 0 : variantIdsSetArray_1.has(variantId))) {
                            acc.push({
                                id: variantId,
                                quantity: (item === null || item === void 0 ? void 0 : item.quantity) || 1,
                            });
                        }
                        return acc;
                    }, []);
                    return [3 /*break*/, 7];
                case 3:
                    variantsAndQuantityArray = updateVariants;
                    return [3 /*break*/, 7];
                case 4:
                    if (isCustomVariantId(updateVariants === null || updateVariants === void 0 ? void 0 : updateVariants.variantId)) {
                        return [2 /*return*/, true];
                    }
                    variant_Id = Number((_d = updateVariants === null || updateVariants === void 0 ? void 0 : updateVariants.variantId) === null || _d === void 0 ? void 0 : _d.split("gid://shopify/ProductVariant/")[1]);
                    if (!Number.isFinite(variant_Id)) {
                        return [2 /*return*/, true];
                    }
                    variantsAndQuantityArray = { id: variant_Id === null || variant_Id === void 0 ? void 0 : variant_Id.toString(), quantity: updateVariants === null || updateVariants === void 0 ? void 0 : updateVariants.quantity };
                    return [3 /*break*/, 7];
                case 5:
                    variantsAndQuantityArray = {};
                    return [3 /*break*/, 7];
                case 6:
                    variantsAndQuantityArray = {};
                    _h.label = 7;
                case 7:
                    isLoading.next(true);
                    if (!((variantsAndQuantityArray && ((_e = Object.keys(variantsAndQuantityArray)) === null || _e === void 0 ? void 0 : _e.length) > 0) || Type === "clear.js")) return [3 /*break*/, 11];
                    _h.label = 8;
                case 8:
                    _h.trys.push([8, 10, , 11]);
                    return [4 /*yield*/, dispatch(dataAddingOnCart(variantsAndQuantityArray, Type))];
                case 9:
                    CartErrorRespose = _h.sent();
                    isLoading.next(false);
                    if (typeof CartErrorRespose === "boolean" && CartErrorRespose) {
                        return [2 /*return*/, true];
                    }
                    else {
                        if ((_f = CartErrorRespose === null || CartErrorRespose === void 0 ? void 0 : CartErrorRespose.toLowerCase()) === null || _f === void 0 ? void 0 : _f.includes("can't add more")) {
                            setAlertErrorMsg({ msg: t("createOrder_ErrorMsgForQuantityLimit"), open: true });
                        }
                        else if ((_g = CartErrorRespose === null || CartErrorRespose === void 0 ? void 0 : CartErrorRespose.toLowerCase()) === null || _g === void 0 ? void 0 : _g.includes("cannot find")) {
                            setAlertErrorMsg({ msg: t("ST_Producttable_CartResponse"), open: true });
                        }
                        else {
                            setAlertErrorMsg({ msg: CartErrorRespose, open: true });
                        }
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 11];
                case 10:
                    error_1 = _h.sent();
                    return [2 /*return*/, false];
                case 11:
                    isLoading.next(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var debouncedProductAddOnCart = useCallback(debounce(productAddOnCart, 600), []);
    useEffect(function () {
        if (!isEditOrder && !isUpdatedCart) {
            readCartProducts();
        }
    }, []);
    useEffect(function () {
        setFinalSelectedProducts(selectedProductArray);
    }, [uncheckedFlag]);
    useEffect(function () {
        var UpdatedSubtotal = calculateTotalVariantPrices(netQuantitySubtotal);
        setMasterSubTotal(UpdatedSubtotal);
        setTotalOrderAmount(UpdatedSubtotal);
        if (ShopApplyDiscount || isDiscoutAppliedInEditDraft) {
            applyDiscountInSubtotale(UpdatedSubtotal);
        }
    }, [netQuantitySubtotal, finalSelectedProducts, wholePriceObj, discount_idObject]);
    useEffect(function () {
        setFinalSelectedProducts([]);
        setFinalSelectedProducts(function (prevState) {
            var newState = __spreadArray(__spreadArray([], prevState, true), selectedProductArray, true);
            debouncedProductAddOnCart(selectedVariantArray, "add.js", newState);
            return newState;
        });
    }, [selectedProductArray, debouncedProductAddOnCart]);
    // When edit/duplicate: populate line-item discounts from productDetailsArray so they show in the table
    useEffect(function () {
        var _a, _b, _c, _d;
        if (isEditOrder && ((_d = (_c = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.editDraftOrder) === null || _b === void 0 ? void 0 : _b.productDetailsArray) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0) {
            ReduxDiscountedValues();
        }
    }, [isEditOrder, (_s = (_r = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _r === void 0 ? void 0 : _r.productDetailsArray) === null || _s === void 0 ? void 0 : _s.length]);
    useEffect(function () {
        var _a, _b, _c;
        if (netQuantitySubtotal && ((_a = Object.keys(netQuantitySubtotal)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            (_b = Object.keys(netQuantitySubtotal)) === null || _b === void 0 ? void 0 : _b.forEach(function (variantId) {
                var foundVariant = selectedVariantArray === null || selectedVariantArray === void 0 ? void 0 : selectedVariantArray.find(function (item) { return variantId === (item === null || item === void 0 ? void 0 : item.variantId); });
                var wholeSalePrice = handleWholesalePriceMapping(foundVariant);
                updateSubtotal(variantId, wholeSalePrice);
            });
            if (isEditOrder) {
                if ((selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.PriceList) && ((_c = Object === null || Object === void 0 ? void 0 : Object.keys(wholePriceObj)) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                    setAlertErrorMsg({ msg: t("Edit_DraftOrderAlert_Msg"), open: true, severity: "success" });
                }
                ReduxDiscountedValues();
            }
        }
    }, [createOrderTabReduxState, finalSelectedProducts]);
    useEffect(function () {
        handleQuantityAndReduxStateUpdate();
    }, [netQuantitySubtotal, isDiscountError, isQuantityError]);
    // Sync Redux when customer changes in duplicate mode to ensure button stays enabled
    // This is needed because customer can be removed/changed in duplicate mode
    useEffect(function () {
        var _a, _b;
        var isDuplicate = ((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _a === void 0 ? void 0 : _a.isDuplicate) === true;
        var currentIsEditOrder = ((_b = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _b === void 0 ? void 0 : _b.actionEvent) === EDIT_ORDER_FLAG;
        // In duplicate mode, ensure Redux stays synced when customer changes
        if (isDuplicate && currentIsEditOrder && selectedVariantArray && selectedVariantArray.length > 0) {
            handleQuantityAndReduxStateUpdate();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createOrderTabReduxState === null || createOrderTabReduxState === void 0 ? void 0 : createOrderTabReduxState.customerName, (_t = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _t === void 0 ? void 0 : _t.isDuplicate, (_u = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _u === void 0 ? void 0 : _u.actionEvent]);
    var updateSubtotal = function (variantId, variantPrice) {
        try {
            if (ShopApplyDiscount) {
                setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                    var _a;
                    var _b, _c, _d, _e, _f;
                    var quantity = ((_b = prevNetQuantitySubtotal[variantId]) === null || _b === void 0 ? void 0 : _b.quantity) || 1;
                    var subtotal = quantity * variantPrice;
                    var discountExists = discount_idObject === null || discount_idObject === void 0 ? void 0 : discount_idObject.hasOwnProperty(variantId);
                    if (discountExists) {
                        var discountValue = discount_idObject[variantId] || 0;
                        var discountAmount = parseFloat(typeof discountValue === "number" ? discountValue === null || discountValue === void 0 ? void 0 : discountValue.toFixed(2) : discountValue === null || discountValue === void 0 ? void 0 : discountValue.toString());
                        if (selectedDiscountType === "percentage" && discountAmount >= 0 && discountAmount <= 100) {
                            // Calculate discount on per-unit price first
                            var discountedPrice = parseFloat((_c = (variantPrice - (variantPrice * discountAmount) / 100)) === null || _c === void 0 ? void 0 : _c.toFixed(2));
                            subtotal = parseFloat((_d = (discountedPrice * quantity)) === null || _d === void 0 ? void 0 : _d.toFixed(2)); // Multiply after rounding
                        }
                        else if (selectedDiscountType !== "percentage" && discountAmount >= 0 && discountAmount <= variantPrice) {
                            // Fixed Amount discount: discountAmount is per-unit discount
                            // Apply per-unit discount: (price - perUnitDiscount) × quantity
                            var unitDiscountedPrice = parseFloat((_e = (variantPrice - discountAmount)) === null || _e === void 0 ? void 0 : _e.toFixed(2));
                            subtotal = parseFloat((_f = (unitDiscountedPrice * quantity)) === null || _f === void 0 ? void 0 : _f.toFixed(2));
                        }
                    }
                    return __assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variantId] = __assign(__assign({}, prevNetQuantitySubtotal[variantId]), { subtotal: subtotal }), _a));
                });
            }
            else {
                setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                    var _a;
                    return (__assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variantId] = __assign(__assign({}, prevNetQuantitySubtotal[variantId]), { subtotal: prevNetQuantitySubtotal[variantId].quantity * variantPrice }), _a)));
                });
            }
        }
        catch (error) {
            console.log(error, "error");
        }
        return;
    };
    // Search Product Function
    var handleSearchProductData = function (startCursor, endCursor, makeEmpty, firstCall) { return __awaiter(_this, void 0, void 0, function () {
        var collectionIds, allProducts, action, _a, newProducts, newPageInfo, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 7, , 8]);
                    firstCall ? setGetProductsLoading(true) : setLoadMoreProducts(true);
                    if (!(isShowSpecificProducts && (activeCollectionList === null || activeCollectionList === void 0 ? void 0 : activeCollectionList.length) > 0)) return [3 /*break*/, 4];
                    if (!(collectionProductsData && (collectionProductsData === null || collectionProductsData === void 0 ? void 0 : collectionProductsData.length) > 0)) return [3 /*break*/, 1];
                    if (makeEmpty != "" && productSearchText !== "" && isShowSpecificProducts) {
                        filterProductsForSpecificCollections(productSearchText, collectionProductsData, true);
                    }
                    else {
                        applyCollectionPage(collectionProductsData, 0);
                    }
                    return [3 /*break*/, 3];
                case 1:
                    collectionIds = activeCollectionList.map(function (c) { return c === null || c === void 0 ? void 0 : c.CollectionId; });
                    return [4 /*yield*/, fetchAllProductsForCollections(collectionIds, productSearchText, storefrontAccessToken !== null && storefrontAccessToken !== void 0 ? storefrontAccessToken : "")];
                case 2:
                    allProducts = _b.sent();
                    action = {
                        payload: allProducts,
                        type: SalesRepDataActionType.COLLECTION_PRODUCTS_DATA,
                    };
                    dispatch(action);
                    applyCollectionPage(allProducts, 0);
                    _b.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, GetProductDataService(makeEmpty == "" ? "" : productSearchText, storefrontAccessToken, startCursor, endCursor).then(function (data) { return data; })];
                case 5:
                    _a = _b.sent(), newProducts = _a.products, newPageInfo = _a.pageInfo;
                    if (makeEmpty == "") {
                        setProductsArray(newProducts);
                    }
                    else {
                        filterProductsForSpecificCollections(productSearchText, newProducts);
                    }
                    setPageInfo(newPageInfo);
                    _b.label = 6;
                case 6:
                    firstCall ? setGetProductsLoading(false) : setLoadMoreProducts(false);
                    return [3 /*break*/, 8];
                case 7:
                    error_2 = _b.sent();
                    console.error("Error fetching products:", error_2);
                    setLoadMoreProducts(false);
                    firstCall ? setGetProductsLoading(false) : setLoadMoreProducts(false);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var applyDiscountInSubtotale = function (subtotal) {
        var _a;
        var DiscountAmount = 0;
        if (discount_idObject["discountOnSubTotal"]) {
            var discountSubtotalValue = discount_idObject["discountOnSubTotal"];
            var DiscountOnSubtotal = parseFloat(typeof discountSubtotalValue === "number" ? discountSubtotalValue === null || discountSubtotalValue === void 0 ? void 0 : discountSubtotalValue.toFixed(2) : discountSubtotalValue === null || discountSubtotalValue === void 0 ? void 0 : discountSubtotalValue.toString());
            if (DiscountOnSubtotal) {
                if (selectedDiscountType === "percentage") {
                    if (DiscountOnSubtotal !== undefined && DiscountOnSubtotal >= 0 && DiscountOnSubtotal <= 100) {
                        var discountValue = (subtotal * DiscountOnSubtotal) / 100;
                        DiscountAmount = parseFloat(discountValue === null || discountValue === void 0 ? void 0 : discountValue.toFixed(2)); // Round properly before subtraction
                        setTotalOrderAmount(parseFloat((_a = (subtotal - DiscountAmount)) === null || _a === void 0 ? void 0 : _a.toFixed(2))); // Ensure final value is rounded
                    }
                }
                else {
                    if (DiscountOnSubtotal !== undefined && DiscountOnSubtotal >= 0 && DiscountOnSubtotal <= subtotal) {
                        setTotalOrderAmount(subtotal - DiscountOnSubtotal);
                    }
                }
            }
        }
    };
    var handlePrevClick = function () {
        var _a, _b;
        if (isShowSpecificProducts && (collectionProductsData === null || collectionProductsData === void 0 ? void 0 : collectionProductsData.length) > 0) {
            if (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasPreviousPage) {
                var list = getListToPaginate();
                applyCollectionPage(list, collectionProductsPageIndex - 1);
                (_a = tableContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
            }
        }
        else if (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasPreviousPage) {
            handleSearchProductData("", pageInfo.startCursor);
            (_b = tableContainerRef.current) === null || _b === void 0 ? void 0 : _b.scrollTo(0, 0);
        }
    };
    var handleNextClick = function () {
        var _a, _b;
        if (isShowSpecificProducts && (collectionProductsData === null || collectionProductsData === void 0 ? void 0 : collectionProductsData.length) > 0) {
            if (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage) {
                var list = getListToPaginate();
                applyCollectionPage(list, collectionProductsPageIndex + 1);
                (_a = tableContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
            }
        }
        else if (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage) {
            handleSearchProductData(pageInfo.endCursor, "");
            (_b = tableContainerRef.current) === null || _b === void 0 ? void 0 : _b.scrollTo(0, 0);
        }
    };
    var handleProductTableSearchPopup = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSearchTablePopupOpen(true);
                    return [4 /*yield*/, handleSearchProductData("", "", "", true)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var closePopupForSearchProductData = function () {
        setSearchTablePopupOpen(false);
        setGetProductsLoading(false);
        makeFieldsEmpty();
    };
    var makeFieldsEmpty = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setProductSearchText("");
                    if (!isShowSpecificProducts) return [3 /*break*/, 1];
                    applyCollectionPage(collectionProductsData, 0);
                    return [3 /*break*/, 3];
                case 1:
                    setProductsArray([]);
                    return [4 /*yield*/, handleSearchProductData("", "", "", true)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSearchTextChange = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            value = e.target.value;
            setProductSearchText(value);
            if (isShowSpecificProducts) {
                if (value === "") {
                    applyCollectionPage(collectionProductsData, 0);
                }
            }
            return [2 /*return*/];
        });
    }); };
    var filterProductsForSpecificCollections = function (searchValue, collectionProductsArray, isSpecificCollection) {
        var _a, _b;
        if (isSpecificCollection === void 0) { isSpecificCollection = false; }
        var lowerCasedSearchWords = (_b = (_a = searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.split(" ");
        if (!isSpecificCollection || (lowerCasedSearchWords === null || lowerCasedSearchWords === void 0 ? void 0 : lowerCasedSearchWords.length) === 0) {
            applyCollectionPage(collectionProductsArray, 0);
            return;
        }
        var filtered = filterCollectionBySearch(collectionProductsArray, searchValue);
        applyCollectionPage(filtered, 0);
    };
    var handleKeyDown = function (event) {
        if (event.key === "Enter" && event.keyCode === 13) {
            if (productSearchText !== "" && isShowSpecificProducts && (activeCollectionList === null || activeCollectionList === void 0 ? void 0 : activeCollectionList.length) > 0) {
                filterProductsForSpecificCollections(productSearchText, collectionProductsData, true);
            }
            else {
                handleSearchProductData();
            }
        }
    };
    // Function to toggle the selection of a variant
    function checkUncheckProductVariant(event, type, product, variant, uncheckFromSelected) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var checked, tempVariantsObj_1, filteredVariants, existingProductIndex, updatedSelectedData, updatedNetQuantitySubtotal_1, updatedSelectedVariantObject, updatedNetQuantitySubtotal_2, updates_1, tempVariants_1, updatedNetQuantitySubtotal, updates_2, variantId, error_3;
            var _b, _c;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 7, , 8]);
                        checked = event.target.checked;
                        if (!(type === "isProduct")) return [3 /*break*/, 5];
                        tempVariantsObj_1 = product === null || product === void 0 ? void 0 : product.variants;
                        if (!checked) return [3 /*break*/, 1];
                        filteredVariants = tempVariantsObj_1 === null || tempVariantsObj_1 === void 0 ? void 0 : tempVariantsObj_1.filter(function (variant) { return variant.availableForSale; });
                        if (selectedProductArray === null || selectedProductArray === void 0 ? void 0 : selectedProductArray.some(function (item) { return item.productId === product.productId; })) {
                            existingProductIndex = selectedProductArray.findIndex(function (item) { return item.productId === product.productId; });
                            if (existingProductIndex !== -1) {
                                updatedSelectedData = __spreadArray([], selectedProductArray, true);
                                updatedSelectedData[existingProductIndex].variants = filteredVariants;
                                setSelectedProductArray(updatedSelectedData);
                            }
                        }
                        else {
                            // Product not present, add it with the new variant
                            setSelectedProductArray(__spreadArray(__spreadArray([], selectedProductArray, true), [__assign(__assign({}, product), { variants: filteredVariants })], false));
                            setSelectedProductIdArray(__spreadArray(__spreadArray([], selectedProductIdArray, true), [product.productId], false));
                        }
                        setSelectedVariantArray(__spreadArray(__spreadArray([], selectedVariantArray, true), filteredVariants, true));
                        updatedNetQuantitySubtotal_1 = __assign({}, netQuantitySubtotal);
                        filteredVariants === null || filteredVariants === void 0 ? void 0 : filteredVariants.forEach(function (variantToAdd) {
                            updatedNetQuantitySubtotal_1[variantToAdd.variantId] = {
                                quantity: 1,
                                subtotal: variantToAdd.variantPrice,
                            };
                        });
                        setNetQuantitySubtotal(updatedNetQuantitySubtotal_1);
                        return [3 /*break*/, 4];
                    case 1:
                        // Uncheck product
                        setUncheckedFlag(!uncheckedFlag);
                        setSelectedProductArray(selectedProductArray === null || selectedProductArray === void 0 ? void 0 : selectedProductArray.filter(function (item) { return item.productId !== product.productId; }));
                        setSelectedProductIdArray(selectedProductIdArray === null || selectedProductIdArray === void 0 ? void 0 : selectedProductIdArray.filter(function (id) { return id !== product.productId; }));
                        updatedSelectedVariantObject = selectedVariantArray === null || selectedVariantArray === void 0 ? void 0 : selectedVariantArray.filter(function (selectedVariant) { return !(tempVariantsObj_1 === null || tempVariantsObj_1 === void 0 ? void 0 : tempVariantsObj_1.some(function (tempVariant) { return tempVariant.variantId === selectedVariant.variantId; })); });
                        setSelectedVariantArray(updatedSelectedVariantObject);
                        if (!uncheckFromSelected) return [3 /*break*/, 4];
                        updatedNetQuantitySubtotal_2 = __assign({}, netQuantitySubtotal);
                        updates_1 = {};
                        tempVariantsObj_1 === null || tempVariantsObj_1 === void 0 ? void 0 : tempVariantsObj_1.forEach(function (variantToRemove) {
                            var _a;
                            delete updatedNetQuantitySubtotal_2[variantToRemove === null || variantToRemove === void 0 ? void 0 : variantToRemove.variantId];
                            if (ShopApplyDiscount || isDiscoutAppliedInEditDraft) {
                                delete discount_idObject[variantToRemove === null || variantToRemove === void 0 ? void 0 : variantToRemove.variantId];
                            }
                            if (!isCustomVariant(variantToRemove)) {
                                var variantId = Number((_a = variantToRemove === null || variantToRemove === void 0 ? void 0 : variantToRemove.variantId) === null || _a === void 0 ? void 0 : _a.split("gid://shopify/ProductVariant/")[1]);
                                if (Number.isFinite(variantId)) {
                                    updates_1[variantId] = 0;
                                }
                            }
                        });
                        if (!(Object.keys(updates_1).length > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, productAddOnCart("", "update.js", updates_1)];
                    case 2:
                        _d.sent();
                        _d.label = 3;
                    case 3:
                        setDiscount_idObject(__assign(__assign({}, discount_idObject), (_b = {}, _b["discountOnSubTotal"] = 0, _b)));
                        setNetQuantitySubtotal(updatedNetQuantitySubtotal_2);
                        _d.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        if (checked) {
                            // isVariant
                            if (!(selectedProductArray === null || selectedProductArray === void 0 ? void 0 : selectedProductArray.some(function (item) { return item.productId === product.productId; }))) {
                                // Product not present, add it with the new variant
                                setSelectedProductArray(__spreadArray(__spreadArray([], selectedProductArray, true), [__assign(__assign({}, product), { variants: [variant] })], false));
                                setSelectedProductIdArray(__spreadArray(__spreadArray([], selectedProductIdArray, true), [product.productId], false));
                            }
                            else {
                                // Product already exists, update the variants array
                                setSelectedProductArray(function (prevSelectedData) {
                                    return prevSelectedData === null || prevSelectedData === void 0 ? void 0 : prevSelectedData.map(function (item) { return (item.productId === product.productId ? __assign(__assign({}, item), { variants: __spreadArray(__spreadArray([], item.variants, true), [variant], false) }) : item); });
                                });
                            }
                            setSelectedVariantArray(__spreadArray(__spreadArray([], selectedVariantArray, true), [variant], false));
                            // Update net quantity subtotal
                            setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                                var _a;
                                return (__assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variant.variantId] = {
                                    quantity: 1,
                                    subtotal: variant.variantPrice,
                                }, _a)));
                            });
                        }
                        else {
                            // Uncheck variant
                            setUncheckedFlag(!uncheckedFlag);
                            setSelectedVariantArray(function (prevSelectedVariantObject) { return prevSelectedVariantObject === null || prevSelectedVariantObject === void 0 ? void 0 : prevSelectedVariantObject.filter(function (v) { return v.variantId !== variant.variantId; }); });
                            setSelectedProductArray(function (prevSelectedData) {
                                return prevSelectedData === null || prevSelectedData === void 0 ? void 0 : prevSelectedData.map(function (item) { var _a; return item.productId === product.productId ? __assign(__assign({}, item), { variants: (_a = item.variants) === null || _a === void 0 ? void 0 : _a.filter(function (v) { return v.variantId !== variant.variantId; }) }) : item; });
                            });
                            tempVariants_1 = product === null || product === void 0 ? void 0 : product.variants;
                            setSelectedVariantArray(function (prevSelectedVariantObject) {
                                var variantFoundInSelectedArray = tempVariants_1 === null || tempVariants_1 === void 0 ? void 0 : tempVariants_1.some(function (tempVariant) {
                                    return prevSelectedVariantObject === null || prevSelectedVariantObject === void 0 ? void 0 : prevSelectedVariantObject.some(function (selectedVariant) { return selectedVariant.variantId === tempVariant.variantId; });
                                });
                                if (!variantFoundInSelectedArray) {
                                    setSelectedProductIdArray(function (prevSelectedProductIdObject) { return prevSelectedProductIdObject === null || prevSelectedProductIdObject === void 0 ? void 0 : prevSelectedProductIdObject.filter(function (id) { return id !== product.productId; }); });
                                    setSelectedProductArray(function (prevSelectedData) { return prevSelectedData === null || prevSelectedData === void 0 ? void 0 : prevSelectedData.filter(function (item) { return item.productId !== product.productId; }); });
                                }
                                return prevSelectedVariantObject === null || prevSelectedVariantObject === void 0 ? void 0 : prevSelectedVariantObject.filter(function (v) { return v.variantId !== variant.variantId; });
                            });
                            // this will Uncheck from selected products table
                            if (uncheckFromSelected) {
                                updatedNetQuantitySubtotal = __assign({}, netQuantitySubtotal);
                                updates_2 = {};
                                delete updatedNetQuantitySubtotal[variant === null || variant === void 0 ? void 0 : variant.variantId];
                                if (ShopApplyDiscount || isDiscoutAppliedInEditDraft) {
                                    delete discount_idObject[variant === null || variant === void 0 ? void 0 : variant.variantId];
                                }
                                if (!isCustomVariant(variant)) {
                                    variantId = Number((_a = variant.variantId) === null || _a === void 0 ? void 0 : _a.split("gid://shopify/ProductVariant/")[1]);
                                    if (Number.isFinite(variantId)) {
                                        updates_2[variantId] = 0;
                                        setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, productAddOnCart("", "update.js", updates_2)];
                                                    case 1:
                                                        _a.sent();
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); }, 800);
                                    }
                                }
                                setDiscount_idObject(__assign(__assign({}, discount_idObject), (_c = {}, _c["discountOnSubTotal"] = 0, _c)));
                                setNetQuantitySubtotal(updatedNetQuantitySubtotal);
                            }
                        }
                        _d.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_3 = _d.sent();
                        return [2 /*return*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    var calculateTotalVariantPrices = function (updatedNetQuantitySubtotal) {
        var getPrice = function (variant) {
            var _a, _b;
            if (isCustomVariant(variant)) {
                return (_a = variant === null || variant === void 0 ? void 0 : variant.variantPrice) !== null && _a !== void 0 ? _a : 0;
            }
            var variantIdParts = (_b = variant.variantId) === null || _b === void 0 ? void 0 : _b.split("gid://shopify/ProductVariant/");
            var numericVariantId = Number(variantIdParts === null || variantIdParts === void 0 ? void 0 : variantIdParts[1]);
            var variantPrice = (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.PriceList) && (createOrderTabReduxState === null || createOrderTabReduxState === void 0 ? void 0 : createOrderTabReduxState.customerName) !== "" && Number.isFinite(numericVariantId)
                ? wholePriceObj[numericVariantId] || variant.variantPrice
                : variant.variantPrice;
            return variantPrice;
        };
        var getDiscountedPrice = function (price, quantity, variantId) {
            var _a, _b, _c, _d, _e;
            if (isCustomVariantId(variantId))
                return price * quantity;
            if (!ShopApplyDiscount && !isDiscoutAppliedInEditDraft)
                return price * quantity;
            var discountValue = discount_idObject[variantId] || 0;
            var discountAmount = parseFloat(typeof discountValue === "number" ? discountValue.toFixed(2) : discountValue === null || discountValue === void 0 ? void 0 : discountValue.toString());
            if ((discount_idObject === null || discount_idObject === void 0 ? void 0 : discount_idObject.hasOwnProperty(variantId)) && discountAmount !== undefined) {
                if (selectedDiscountType === "percentage" && discountAmount >= 0 && discountAmount <= 100) {
                    // Calculate discount per unit price
                    var unitDiscountedPrice = parseFloat((_a = (price - (price * discountAmount) / 100)) === null || _a === void 0 ? void 0 : _a.toFixed(2));
                    // Calculate final subtotal after applying quantity
                    return parseFloat((_b = (unitDiscountedPrice * quantity)) === null || _b === void 0 ? void 0 : _b.toFixed(2));
                }
                else if (discountAmount >= 0 && discountAmount <= price) {
                    // Fixed Amount discount: discountAmount is per-unit discount
                    // Apply per-unit discount: (price - perUnitDiscount) × quantity
                    var unitDiscountedPrice = parseFloat((_c = (price - discountAmount)) === null || _c === void 0 ? void 0 : _c.toFixed(2));
                    return parseFloat((_d = (unitDiscountedPrice * quantity)) === null || _d === void 0 ? void 0 : _d.toFixed(2));
                }
            }
            return parseFloat((_e = (price * quantity)) === null || _e === void 0 ? void 0 : _e.toFixed(2));
        };
        var totalOrderSubtotal = selectedVariantArray === null || selectedVariantArray === void 0 ? void 0 : selectedVariantArray.reduce(function (total, variant) {
            var _a, _b;
            var quantity = ((_a = updatedNetQuantitySubtotal[variant === null || variant === void 0 ? void 0 : variant.variantId]) === null || _a === void 0 ? void 0 : _a.quantity) || 1;
            var price = getPrice(variant);
            var subtotal = getDiscountedPrice(price, quantity, variant === null || variant === void 0 ? void 0 : variant.variantId);
            return parseFloat((_b = (total + subtotal)) === null || _b === void 0 ? void 0 : _b.toFixed(2));
        }, 0);
        if (ShopApplyDiscount || isDiscoutAppliedInEditDraft) {
            setTotalOrderAmount(totalOrderSubtotal);
        }
        return totalOrderSubtotal;
    };
    // Set Redux discount value:
    var ReduxDiscountedValues = function () {
        var _a, _b, _c, _d, _e;
        var draftOrder = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj;
        var productDetailsArray = (_d = (_c = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.editDraftOrder) === null || _b === void 0 ? void 0 : _b.productDetailsArray) !== null && _c !== void 0 ? _c : editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.productDetailsArray) !== null && _d !== void 0 ? _d : [];
        try {
            var lineItemDiscounts_1 = {};
            var appliedDiscountOnSubTotal = void 0;
            // Track discount types to determine dropdown type at the end
            var hasDollarDiscount_1 = false;
            var hasPercentageDiscount_1 = false;
            if (draftOrder) {
                var lineItems = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.line_items;
                var orderDiscount = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.applied_discount;
                // Process order-level discount: Always check value_type first
                if (orderDiscount && ((_e = Object.keys(orderDiscount)) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                    var orderDiscountType = getDiscountTypeFromValueType(orderDiscount);
                    if (orderDiscountType === "dollar") {
                        hasDollarDiscount_1 = true;
                        // For dollar: prefer amount, fallback to value
                        var amount = (orderDiscount === null || orderDiscount === void 0 ? void 0 : orderDiscount.amount) != null && (orderDiscount === null || orderDiscount === void 0 ? void 0 : orderDiscount.amount) !== ""
                            ? parseFloat(String(orderDiscount.amount))
                            : NaN;
                        appliedDiscountOnSubTotal = !Number.isNaN(amount) && amount > 0
                            ? amount
                            : (Number(orderDiscount === null || orderDiscount === void 0 ? void 0 : orderDiscount.value) || 0);
                    }
                    else {
                        // Percentage discount
                        hasPercentageDiscount_1 = true;
                        appliedDiscountOnSubTotal = (orderDiscount === null || orderDiscount === void 0 ? void 0 : orderDiscount.value) != null && (orderDiscount === null || orderDiscount === void 0 ? void 0 : orderDiscount.value) !== ""
                            ? Number(orderDiscount.value)
                            : undefined;
                    }
                }
                // Do NOT use total_discounts as order-level: it can be the sum of line-item discounts only (e.g. 2+4=6).
                // Only show order-level discount when Shopify has an explicit order-level applied_discount.
                // Process line-item discounts: Always check value_type first
                if (lineItems && Array.isArray(lineItems)) {
                    lineItems === null || lineItems === void 0 ? void 0 : lineItems.forEach(function (variant) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                        var variantId = variant === null || variant === void 0 ? void 0 : variant.variant_id;
                        // Check if discount exists (either value or amount)
                        if (!variantId || (!((_a = variant.applied_discount) === null || _a === void 0 ? void 0 : _a.value) &&
                            (!((_b = variant.applied_discount) === null || _b === void 0 ? void 0 : _b.amount) || ((_c = variant.applied_discount) === null || _c === void 0 ? void 0 : _c.amount) === ""))) {
                            return;
                        }
                        setIsEditDraftOrderDiscount(true);
                        var quantity = parseInt((variant === null || variant === void 0 ? void 0 : variant.quantity) || "0");
                        var graphQLVariantId = "gid://shopify/ProductVariant/".concat(variantId);
                        // Get variant price (wholesale or retail)
                        var variantPrice;
                        if ((selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.PriceList) && wholePriceObj && ((_d = Object.keys(wholePriceObj)) === null || _d === void 0 ? void 0 : _d.length) > 0 && wholePriceObj[variantId]) {
                            variantPrice = wholePriceObj[variantId];
                        }
                        else {
                            variantPrice = variant === null || variant === void 0 ? void 0 : variant.price;
                        }
                        // Determine discount type from value_type (always check value_type first)
                        var lineItemDiscountType = getDiscountTypeFromValueType(variant.applied_discount);
                        // Track discount type for dropdown
                        if (lineItemDiscountType === "dollar") {
                            hasDollarDiscount_1 = true;
                        }
                        else {
                            hasPercentageDiscount_1 = true;
                        }
                        var subtotalCount;
                        var discountValueToStore;
                        if (lineItemDiscountType === "percentage") {
                            // Percentage discount: use value directly
                            var percentageValue = Number((_e = variant === null || variant === void 0 ? void 0 : variant.applied_discount) === null || _e === void 0 ? void 0 : _e.value) || 0;
                            discountValueToStore = Math.round(percentageValue); // Round percentage to integer
                            lineItemDiscounts_1[graphQLVariantId] = discountValueToStore;
                            // Calculate subtotal: apply percentage discount per unit
                            var unitDiscountedPrice = parseFloat((_f = (variantPrice - (variantPrice * percentageValue) / 100)) === null || _f === void 0 ? void 0 : _f.toFixed(2));
                            subtotalCount = parseFloat((_g = (unitDiscountedPrice * quantity)) === null || _g === void 0 ? void 0 : _g.toFixed(2));
                        }
                        else {
                            // Dollar discount: use value (per unit), not amount (total)
                            // value = per unit discount, amount = total discount (value × quantity)
                            var perUnitDiscount = Number((_h = variant === null || variant === void 0 ? void 0 : variant.applied_discount) === null || _h === void 0 ? void 0 : _h.value) || 0;
                            if (perUnitDiscount <= 0)
                                return;
                            // Store per-unit discount (for text field display and calculations)
                            discountValueToStore = parseFloat(perUnitDiscount.toFixed(2));
                            lineItemDiscounts_1[graphQLVariantId] = discountValueToStore;
                            // Calculate subtotal: apply per-unit discount
                            var unitDiscountedPrice = parseFloat((_j = (variantPrice - perUnitDiscount)) === null || _j === void 0 ? void 0 : _j.toFixed(2));
                            subtotalCount = parseFloat((_k = (unitDiscountedPrice * quantity)) === null || _k === void 0 ? void 0 : _k.toFixed(2));
                        }
                        setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                            var _a;
                            return (__assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[graphQLVariantId] = {
                                quantity: quantity,
                                subtotal: Math === null || Math === void 0 ? void 0 : Math.max(subtotalCount, 0),
                            }, _a)));
                        });
                    });
                }
            }
            // Process productDetailsArray as fallback (only for items not in line_items)
            if ((productDetailsArray === null || productDetailsArray === void 0 ? void 0 : productDetailsArray.length) > 0) {
                try {
                    productDetailsArray.forEach(function (item) {
                        var _a, _b, _c, _d, _e, _f, _g;
                        var row = item;
                        var variantIdRaw = (_a = item === null || item === void 0 ? void 0 : item.variantId) !== null && _a !== void 0 ? _a : row === null || row === void 0 ? void 0 : row.variant_id;
                        if (variantIdRaw == null)
                            return;
                        var graphQLVariantId = String(variantIdRaw).startsWith("gid://") ? String(variantIdRaw) : "gid://shopify/ProductVariant/".concat(variantIdRaw);
                        // Skip if discount already set from line_items (line_items is source of truth)
                        // Also check numeric variant ID format to ensure we catch all matches
                        var numericVariantId = String(variantIdRaw).replace("gid://shopify/ProductVariant/", "");
                        var alreadyHasDiscount = lineItemDiscounts_1[graphQLVariantId] != null ||
                            (numericVariantId && lineItemDiscounts_1["gid://shopify/ProductVariant/".concat(numericVariantId)] != null);
                        if (alreadyHasDiscount)
                            return;
                        var quantity = Number((_b = item === null || item === void 0 ? void 0 : item.quantity) !== null && _b !== void 0 ? _b : 1) || 1;
                        var itemPrice = Number((_d = (_c = item === null || item === void 0 ? void 0 : item.ItemPrice) !== null && _c !== void 0 ? _c : row === null || row === void 0 ? void 0 : row.price) !== null && _d !== void 0 ? _d : 0) || 0;
                        var lineTotal = itemPrice * quantity;
                        if (lineTotal <= 0)
                            return;
                        var appliedDiscount = (_e = item === null || item === void 0 ? void 0 : item.appliedDiscount) !== null && _e !== void 0 ? _e : row === null || row === void 0 ? void 0 : row.applied_discount;
                        // Check if discount exists
                        if (!appliedDiscount || (!(appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.value) && (!(appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.amount) || (appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.amount) === ""))) {
                            // Fallback to TotalDiscount if no appliedDiscount
                            var totalDiscount = Number((_f = item === null || item === void 0 ? void 0 : item.TotalDiscount) !== null && _f !== void 0 ? _f : 0) || 0;
                            if (totalDiscount > 0) {
                                var subtotal_1 = Math.max(0, parseFloat((lineTotal - totalDiscount).toFixed(2)));
                                setNetQuantitySubtotal(function (prev) {
                                    var _a;
                                    return (__assign(__assign({}, prev), (_a = {}, _a[graphQLVariantId] = { quantity: quantity, subtotal: subtotal_1 }, _a)));
                                });
                            }
                            return;
                        }
                        setIsEditDraftOrderDiscount(true);
                        // Determine discount type from value_type (always check value_type first)
                        var productDiscountType = getDiscountTypeFromValueType(appliedDiscount);
                        // Track discount type for dropdown
                        if (productDiscountType === "dollar") {
                            hasDollarDiscount_1 = true;
                        }
                        else {
                            hasPercentageDiscount_1 = true;
                        }
                        var subtotal;
                        var discountValueToStore;
                        if (productDiscountType === "percentage") {
                            // Percentage discount: use value directly
                            var rawValue = appliedDiscount.value;
                            var numVal = Number(rawValue);
                            if (Number.isNaN(numVal) || numVal <= 0)
                                return;
                            // Normalize percentage value (0-100)
                            var pctVal = numVal >= 0 && numVal <= 100 ? numVal : (lineTotal > 0 ? (numVal / lineTotal) * 100 : 0);
                            discountValueToStore = Math.round(pctVal);
                            lineItemDiscounts_1[graphQLVariantId] = discountValueToStore;
                            // Calculate subtotal: apply percentage discount
                            var discountAmount = (lineTotal * discountValueToStore) / 100;
                            subtotal = Math.max(0, parseFloat((lineTotal - discountAmount).toFixed(2)));
                        }
                        else {
                            // Dollar discount: use value (per unit), not amount (total)
                            // value = per unit discount, amount = total discount (value × quantity)
                            var perUnitDiscount = Number(appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.value) || 0;
                            if (perUnitDiscount <= 0)
                                return;
                            // Store per-unit discount (for text field display and calculations)
                            discountValueToStore = parseFloat(perUnitDiscount.toFixed(2));
                            lineItemDiscounts_1[graphQLVariantId] = discountValueToStore;
                            // Calculate subtotal: apply per-unit discount
                            var unitDiscountedPrice = parseFloat((_g = (itemPrice - perUnitDiscount)) === null || _g === void 0 ? void 0 : _g.toFixed(2));
                            subtotal = Math.max(0, parseFloat((unitDiscountedPrice * quantity).toFixed(2)));
                        }
                        setNetQuantitySubtotal(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[graphQLVariantId] = { quantity: quantity, subtotal: subtotal }, _a)));
                        });
                    });
                }
                catch (error) {
                    console.log("Error processing productDetailsArray:", error);
                }
            }
            // Set discount type dropdown at the end based on what was found
            // If we have any dollar discounts, use dollar; otherwise if we have percentage discounts, use percentage
            if (hasDollarDiscount_1) {
                setSelectedDiscountType("dollar");
            }
            else if (hasPercentageDiscount_1) {
                setSelectedDiscountType("percentage");
            }
            // If neither found, keep default (percentage) - no need to set
            if (draftOrder || Object.keys(lineItemDiscounts_1).length > 0) {
                setDiscount_idObject(__assign(__assign({}, lineItemDiscounts_1), { discountOnSubTotal: appliedDiscountOnSubTotal }));
            }
        }
        catch (error) {
            console.log(error, "error");
        }
    };
    var handleDiscountChange = function (e) {
        var discountValue = parseFloat(e.target.value);
        if (e.target.value !== "") {
            var isValidDiscount = selectedDiscountType === "percentage" ? discountValue >= 0 && discountValue <= 100 : !isNaN(discountValue) && discountValue <= masterSubTotal && discountValue >= 0;
            setDiscountState(isValidDiscount ? discountValue : "", !isValidDiscount);
        }
        else {
            setDiscountState("", false);
        }
    };
    var setDiscountState = function (value, isError) {
        var _a, _b;
        setDiscount_idObject(__assign(__assign({}, discount_idObject), (_a = {}, _a["discountOnSubTotal"] = value, _a)));
        setIsDiscountError(__assign(__assign({}, isDiscountError), (_b = {}, _b["discountOnSubTotal"] = isError, _b)));
    };
    // For summary/subtotal discount input (programmatic value)
    var handleDiscountAmountChange = function (amountInput) {
        if (amountInput === "" || amountInput === null || amountInput === undefined) {
            setDiscountState("", false);
            return;
        }
        var num = typeof amountInput === "number" ? amountInput : parseFloat(String(amountInput));
        if (isNaN(num) || num < 0) {
            setDiscountState(num, true);
            return;
        }
        var isPct = selectedDiscountType === "percentage";
        setDiscountState(num, isPct ? num > 100 : num > masterSubTotal);
    };
    // Line discount display: show percentage as integer (no decimals), dollar as-is; no conversion.
    var getDisplayDiscountValue = function (variant) {
        var discountValue = discount_idObject[variant === null || variant === void 0 ? void 0 : variant.variantId];
        if (discountValue === undefined || discountValue === null || discountValue === "")
            return "";
        if (selectedDiscountType === "percentage")
            return Math.round(Number(discountValue));
        return typeof discountValue === "number" ? parseFloat(discountValue.toFixed(2)) : discountValue;
    };
    var getLineDiscountLabel = function (_variantId) { return ""; };
    var handleQuantityAndReduxStateUpdate = function () {
        var _a, _b;
        var isDuplicate = ((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _a === void 0 ? void 0 : _a.isDuplicate) === true;
        var currentIsEditOrder = ((_b = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _b === void 0 ? void 0 : _b.actionEvent) === EDIT_ORDER_FLAG;
        setSelectedVariantArray(function (prevSelectedVariantObject) {
            var updatedVariants = prevSelectedVariantObject === null || prevSelectedVariantObject === void 0 ? void 0 : prevSelectedVariantObject.map(function (variant) {
                var _a;
                return (__assign(__assign({}, variant), { quantity: netQuantitySubtotal[variant.variantId] ? (_a = netQuantitySubtotal[variant.variantId]) === null || _a === void 0 ? void 0 : _a.quantity : 1 }));
            });
            // Only update Redux if variants exist, OR if not in duplicate mode
            // In duplicate mode, preserve Redux state even if variants are temporarily empty
            if (updatedVariants.length > 0 || !(isDuplicate && currentIsEditOrder)) {
                var action = {
                    payload: {
                        selectedProductData: updatedVariants,
                        isDiscountError: isDiscountError,
                        isQuantityError: isQuantityError,
                        discountKeyValueObject: discount_idObject,
                        selectedDiscountType: selectedDiscountType,
                        isDiscoutAppliedInEditDraft: isDiscoutAppliedInEditDraft || ShopApplyDiscount,
                    },
                    type: SalesRepDataActionType.PRODUCT_TABLE_DATA,
                };
                dispatch(action);
            }
            // In duplicate mode, if variants are empty, don't clear Redux - preserve existing state
            return updatedVariants;
        });
    };
    // Add Button Call to show selected products
    var showSelectedProduct = function () {
        try {
            setSearchTablePopupOpen(false);
            makeFieldsEmpty();
        }
        catch (error) {
            return;
        }
    };
    var getLiveDiscountInfoForEditDraft = function (variantId, isDiscountOnVariantId, isLineItemDiscountApplied, discountValueForVariant, discountTypeForVariant) {
        var _a, _b;
        try {
            if (isEditOrder && !isDiscountOnVariantId) {
                var draftOrder = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj;
                if (draftOrder && (draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.line_items)) {
                    var numericVariantId_1 = variantId === null || variantId === void 0 ? void 0 : variantId.replace("gid://shopify/ProductVariant/", "");
                    if (numericVariantId_1) {
                        var lineItem = (_a = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.line_items) === null || _a === void 0 ? void 0 : _a.find(function (item) { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.variant_id) === null || _a === void 0 ? void 0 : _a.toString()) === numericVariantId_1; });
                        // For fixed amount discounts, use value (per unit), not amount (total)
                        if (((_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.applied_discount) === null || _b === void 0 ? void 0 : _b.value) != null && lineItem.applied_discount.value !== "") {
                            var perUnitDiscount = Number(lineItem.applied_discount.value);
                            if (!Number.isNaN(perUnitDiscount) && perUnitDiscount > 0) {
                                return {
                                    isDiscountOnVariantId: true,
                                    isLineItemDiscountApplied: true,
                                    discountValueForVariant: perUnitDiscount,
                                    discountTypeForVariant: "dollar",
                                };
                            }
                        }
                    }
                }
            }
        }
        catch (error) {
            console.log("Error in getLiveDiscountInfoForEditDraft:", error);
        }
        return {
            isDiscountOnVariantId: isDiscountOnVariantId,
            isLineItemDiscountApplied: isLineItemDiscountApplied,
            discountValueForVariant: discountValueForVariant,
            discountTypeForVariant: discountTypeForVariant,
        };
    };
    var debounceTimeoutRef = useRef({});
    function updateNetQuantitySubtotal(value, variantId, variantPrice, actionType, isReadCartData) {
        var _a, _b;
        if (isReadCartData === void 0) { isReadCartData = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var currentQty, nextQty_1, updatedQuantity_1, updateCartObject_1, currentValues_1, getNewQuantity, updatedNetQuantitySubtotal_3, apiResponse, _c;
            var _d, _e;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        // Custom line items should not call Shopify cart.js APIs
                        if (isCustomVariantId(variantId)) {
                            currentQty = Number((_b = (_a = netQuantitySubtotal === null || netQuantitySubtotal === void 0 ? void 0 : netQuantitySubtotal[variantId]) === null || _a === void 0 ? void 0 : _a.quantity) !== null && _b !== void 0 ? _b : 1);
                            if (actionType === "increaseQty")
                                nextQty_1 = currentQty + 1;
                            else if (actionType === "decreaseQty")
                                nextQty_1 = Math.max(currentQty - 1, 1);
                            else
                                nextQty_1 = Number(value);
                            if (!nextQty_1 || nextQty_1 <= 0)
                                nextQty_1 = 1;
                            nextQty_1 = Math.floor(nextQty_1);
                            setIsQuantityError(function (prevIsError) {
                                var _a;
                                return (__assign(__assign({}, prevIsError), (_a = {}, _a[variantId] = false, _a)));
                            });
                            setNetQuantitySubtotal(function (prev) {
                                var _a;
                                var _b;
                                return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = {
                                    quantity: nextQty_1,
                                    subtotal: parseFloat((_b = (nextQty_1 * (variantPrice !== null && variantPrice !== void 0 ? variantPrice : 0))) === null || _b === void 0 ? void 0 : _b.toFixed(2)),
                                }, _a)));
                            });
                            return [2 /*return*/];
                        }
                        if (!(value !== "" && value !== "0" && Number(value) > 0)) return [3 /*break*/, 6];
                        updateCartObject_1 = {};
                        // Reset error state if there's no error
                        setIsQuantityError(function (prevIsError) {
                            var _a;
                            return (__assign(__assign({}, prevIsError), (_a = {}, _a[variantId] = false, _a)));
                        });
                        currentValues_1 = __assign(__assign({}, netQuantitySubtotal), (_d = {}, _d[variantId] = {
                            quantity: Number(value),
                        }, _d));
                        setNetQuantitySubtotal(__assign({}, currentValues_1));
                        if (actionType == "manual") {
                            // Clear any existing timeout for this variant
                            if (debounceTimeoutRef.current[variantId]) {
                                clearTimeout(debounceTimeoutRef.current[variantId]);
                            }
                        }
                        getNewQuantity = function () {
                            var _a;
                            var _b, _c, _d;
                            var value = currentValues_1[variantId].quantity;
                            var currentVariant = netQuantitySubtotal[variantId];
                            if (actionType === "increaseQty") {
                                updatedQuantity_1 = Number(currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.quantity) + 1;
                            }
                            else if (actionType === "decreaseQty") {
                                // "subtract"
                                updatedQuantity_1 = Math.max(Number(currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.quantity) - 1, 1);
                            }
                            else {
                                // if Manually entered number
                                updatedQuantity_1 = Number(value);
                            }
                            var updatedSubtotal = Number(updatedQuantity_1) * variantPrice;
                            // Check if a discount is applicable for this variant
                            var _e = getLiveDiscountInfoForEditDraft(variantId, discount_idObject === null || discount_idObject === void 0 ? void 0 : discount_idObject.hasOwnProperty(variantId), isDiscountAppliedInInline, discount_idObject[variantId], selectedDiscountType), isDiscountOnVariantId = _e.isDiscountOnVariantId, isLineItemDiscountApplied = _e.isLineItemDiscountApplied, discountValueForVariant = _e.discountValueForVariant, discountTypeForVariant = _e.discountTypeForVariant;
                            if (isDiscountOnVariantId && (ShopApplyDiscount || isLineItemDiscountApplied)) {
                                if (discountTypeForVariant === "percentage") {
                                    var discountValue = discountValueForVariant || 0;
                                    var discountAmount = parseFloat(typeof discountValue === "number" ? discountValue === null || discountValue === void 0 ? void 0 : discountValue.toFixed(2) : discountValue === null || discountValue === void 0 ? void 0 : discountValue.toString());
                                    if (discountAmount !== undefined && discountAmount >= 0 && discountAmount <= 100) {
                                        var discountedPrice = variantPrice - (variantPrice * discountAmount) / 100;
                                        discountedPrice = parseFloat(discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.toFixed(2)); // Ensure max 2 decimal places
                                        updatedSubtotal = discountedPrice * updatedQuantity_1;
                                    }
                                }
                                else {
                                    var discountValue = discountValueForVariant || 0;
                                    var discountAmount = parseFloat(typeof discountValue === "number" ? discountValue === null || discountValue === void 0 ? void 0 : discountValue.toFixed(2) : discountValue === null || discountValue === void 0 ? void 0 : discountValue.toString());
                                    if (discountAmount !== undefined && discountAmount >= 0 && discountAmount <= variantPrice) {
                                        // Fixed Amount discount: discountAmount is per-unit discount
                                        // Apply per-unit discount: (price - perUnitDiscount) × quantity
                                        var unitDiscountedPrice = parseFloat((_b = (variantPrice - discountAmount)) === null || _b === void 0 ? void 0 : _b.toFixed(2));
                                        updatedSubtotal = parseFloat((_c = (unitDiscountedPrice * updatedQuantity_1)) === null || _c === void 0 ? void 0 : _c.toFixed(2));
                                    }
                                }
                            }
                            var updated_NetQuantitySubtotal = __assign(__assign({}, netQuantitySubtotal), (_a = {}, _a[variantId] = {
                                quantity: updatedQuantity_1,
                                subtotal: updatedSubtotal,
                            }, _a));
                            updateCartObject_1 = {
                                variantId: variantId,
                                quantity: (_d = updated_NetQuantitySubtotal[variantId]) === null || _d === void 0 ? void 0 : _d.quantity,
                            };
                            return updated_NetQuantitySubtotal;
                        };
                        updatedNetQuantitySubtotal_3 = getNewQuantity();
                        if (!(actionType === "manual")) return [3 /*break*/, 1];
                        debounceTimeoutRef.current[variantId] = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                            var apiResponse, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!(isReadCartData !== "isReadCartData")) return [3 /*break*/, 2];
                                        return [4 /*yield*/, productAddOnCart({}, "change.js", updateCartObject_1)];
                                    case 1:
                                        _a = _b.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = true;
                                        _b.label = 3;
                                    case 3:
                                        apiResponse = _a;
                                        if (apiResponse) {
                                            setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                                                return __assign(__assign({}, prevNetQuantitySubtotal), updatedNetQuantitySubtotal_3);
                                            });
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); }, 1000);
                        return [3 /*break*/, 5];
                    case 1:
                        if (!(isReadCartData !== "isReadCartData")) return [3 /*break*/, 3];
                        return [4 /*yield*/, productAddOnCart({}, "change.js", updateCartObject_1)];
                    case 2:
                        _c = _f.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _c = true;
                        _f.label = 4;
                    case 4:
                        apiResponse = _c;
                        if (apiResponse) {
                            setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                                return __assign(__assign({}, prevNetQuantitySubtotal), updatedNetQuantitySubtotal_3);
                            });
                        }
                        _f.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        if (actionType == "manual") {
                            if (debounceTimeoutRef.current[variantId]) {
                                clearTimeout(debounceTimeoutRef.current[variantId]);
                            }
                        }
                        setAlertErrorMsg({ msg: t("productTable_error_AlertMsg"), open: true });
                        setIsQuantityError(__assign(__assign({}, isQuantityError), (_e = {}, _e[variantId] = true, _e)));
                        setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                            var _a;
                            return (__assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variantId] = __assign(__assign({}, prevNetQuantitySubtotal[variantId]), { quantity: value, subtotal: 0 }), _a)));
                        });
                        return [2 /*return*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    var removeAllSelectedProducts = function () {
        try {
            setFinalSelectedProducts([]);
            setNetQuantitySubtotal({});
            setSelectedProductIdArray([]);
            setSelectedVariantArray([]);
            setSelectedProductArray([]);
            makeFieldsEmpty();
            setTotalOrderAmount(0);
            setDiscount_idObject({});
            productAddOnCart({}, "clear.js"); //Clear Cart
        }
        catch (error) {
            return;
        }
    };
    // Pricelist mapping
    var handleWholesalePriceMapping = function (variant) {
        var _a, _b, _c;
        if (variant != null && variant != undefined) {
            if (isCustomVariant(variant)) {
                return (_a = variant === null || variant === void 0 ? void 0 : variant.variantPrice) !== null && _a !== void 0 ? _a : 0;
            }
            var splitedVariantId = Number((_b = variant === null || variant === void 0 ? void 0 : variant.variantId) === null || _b === void 0 ? void 0 : _b.split("gid://shopify/ProductVariant/")[1]);
            if ((selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.PriceList) && wholePriceObj && ((_c = Object.keys(wholePriceObj)) === null || _c === void 0 ? void 0 : _c.length) > 0 && wholePriceObj[splitedVariantId]) {
                return wholePriceObj[splitedVariantId]; //wholesale price
            }
            else {
                return variant === null || variant === void 0 ? void 0 : variant.variantPrice; //retail price
            }
        }
    };
    var readCartProducts = function () { return __awaiter(_this, void 0, void 0, function () {
        var responseGetCart, existingCustomVariants, existingCustomIds_1, cartItems, productsArray_1, draftOrderObj_1, lineItems;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(gettingCartData())];
                case 1:
                    responseGetCart = _f.sent();
                    try {
                        existingCustomVariants = (selectedVariantArray !== null && selectedVariantArray !== void 0 ? selectedVariantArray : []).filter(function (v) { return isCustomVariant(v); });
                        existingCustomIds_1 = new Set(existingCustomVariants
                            .map(function (v) { return ((v === null || v === void 0 ? void 0 : v.customLineItemId) ? v.customLineItemId : typeof (v === null || v === void 0 ? void 0 : v.variantId) === "string" ? v.variantId.replace(CUSTOM_VARIANT_PREFIX, "") : ""); })
                            .filter(function (x) { return !!x; }));
                        // Reset table state before rehydrating from cart.js to avoid duplicates
                        setFinalSelectedProducts([]);
                        setSelectedProductArray([]);
                        setSelectedProductIdArray([]);
                        setSelectedVariantArray([]);
                        setNetQuantitySubtotal({});
                        setGetProductsLoading(true);
                        cartItems = (responseGetCart === null || responseGetCart === void 0 ? void 0 : responseGetCart.status) === 200 ? (_b = (_a = responseGetCart === null || responseGetCart === void 0 ? void 0 : responseGetCart.data) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [] : [];
                        productsArray_1 = (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) > 0 ? handleMakeFormatArray(cartItems) : [];
                        setFinalSelectedProducts(productsArray_1);
                        setSelectedProductArray(productsArray_1);
                        setSelectedProductIdArray(productsArray_1 === null || productsArray_1 === void 0 ? void 0 : productsArray_1.map(function (_a) {
                            var productId = _a.productId;
                            return productId;
                        }));
                        // 1) Restore locally edited custom items (if any)
                        existingCustomVariants === null || existingCustomVariants === void 0 ? void 0 : existingCustomVariants.forEach(function (v) {
                            var _a, _b, _c, _d, _e, _f, _g;
                            var id = ((_a = v === null || v === void 0 ? void 0 : v.customLineItemId) !== null && _a !== void 0 ? _a : (typeof (v === null || v === void 0 ? void 0 : v.variantId) === "string" ? v.variantId.replace(CUSTOM_VARIANT_PREFIX, "") : "")).toString();
                            if (!id)
                                return;
                            // Read weight and weight_unit from variant
                            var weight = (v === null || v === void 0 ? void 0 : v.weight) !== undefined && (v === null || v === void 0 ? void 0 : v.weight) !== null && (v === null || v === void 0 ? void 0 : v.weight) > 0 ? Number(v.weight) : undefined;
                            var weight_unit = (v === null || v === void 0 ? void 0 : v.weight_unit) ? v.weight_unit.toString() : undefined;
                            upsertCustomLineItem({
                                customLineItemId: id,
                                title: ((_c = (_b = v === null || v === void 0 ? void 0 : v.name) !== null && _b !== void 0 ? _b : v === null || v === void 0 ? void 0 : v.title) !== null && _c !== void 0 ? _c : "Custom item").toString(),
                                price: ((_d = v === null || v === void 0 ? void 0 : v.price) !== null && _d !== void 0 ? _d : (Number((_e = v === null || v === void 0 ? void 0 : v.variantPrice) !== null && _e !== void 0 ? _e : 0) || 0).toFixed(2)).toString(),
                                quantity: Math.max(1, Number((_f = v === null || v === void 0 ? void 0 : v.quantity) !== null && _f !== void 0 ? _f : 1) || 1),
                                taxable: v === null || v === void 0 ? void 0 : v.taxable,
                                isPhysicalProduct: !!((_g = v === null || v === void 0 ? void 0 : v.isPhysicalProduct) !== null && _g !== void 0 ? _g : v === null || v === void 0 ? void 0 : v.requires_shipping),
                                weight: weight,
                                weight_unit: weight_unit,
                            });
                        });
                        // 2) Hydrate custom items from draft order redux (only those not already restored)
                        if (isEditOrder) {
                            draftOrderObj_1 = (_e = (_d = (_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.editDraftOrder) === null || _d === void 0 ? void 0 : _d.draftOrderObj) !== null && _e !== void 0 ? _e : {};
                            lineItems = Array.isArray(draftOrderObj_1 === null || draftOrderObj_1 === void 0 ? void 0 : draftOrderObj_1.line_items) ? draftOrderObj_1.line_items : [];
                            lineItems.forEach(function (li, idx) {
                                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                                var isCustom = (li === null || li === void 0 ? void 0 : li.custom) === true || (li === null || li === void 0 ? void 0 : li.isCustom) === true || (li === null || li === void 0 ? void 0 : li.variant_id) == null;
                                if (!isCustom)
                                    return;
                                var stableId = ((_b = (_a = li === null || li === void 0 ? void 0 : li.admin_graphql_api_id) !== null && _a !== void 0 ? _a : li === null || li === void 0 ? void 0 : li.id) !== null && _b !== void 0 ? _b : "".concat((_d = (_c = draftOrderObj_1 === null || draftOrderObj_1 === void 0 ? void 0 : draftOrderObj_1.id) !== null && _c !== void 0 ? _c : draftOrderObj_1 === null || draftOrderObj_1 === void 0 ? void 0 : draftOrderObj_1.order_id) !== null && _d !== void 0 ? _d : "draft", "_").concat(idx)).toString();
                                if (!stableId || existingCustomIds_1.has(stableId))
                                    return;
                                // Read weight and weight_unit from backend response
                                var _k = parseCustomLineItemWeight(li), weight = _k.weight, weight_unit = _k.weight_unit;
                                upsertCustomLineItem({
                                    customLineItemId: stableId,
                                    title: ((_f = (_e = li === null || li === void 0 ? void 0 : li.title) !== null && _e !== void 0 ? _e : li === null || li === void 0 ? void 0 : li.name) !== null && _f !== void 0 ? _f : "Custom item").toString(),
                                    price: ((_g = li === null || li === void 0 ? void 0 : li.price) !== null && _g !== void 0 ? _g : "0").toString(),
                                    quantity: Math.max(1, Number((_h = li === null || li === void 0 ? void 0 : li.quantity) !== null && _h !== void 0 ? _h : 1) || 1),
                                    taxable: li === null || li === void 0 ? void 0 : li.taxable,
                                    isPhysicalProduct: !!((_j = li === null || li === void 0 ? void 0 : li.requires_shipping) !== null && _j !== void 0 ? _j : li === null || li === void 0 ? void 0 : li.isPhysicalProduct),
                                    weight: weight,
                                    weight_unit: weight_unit,
                                });
                            });
                        }
                        handleQuantityAndReduxStateUpdate();
                    }
                    catch (_g) {
                        // never allow cart hydration to crash edit/create flow
                    }
                    finally {
                        setGetProductsLoading(false);
                    }
                    isLoading.next(false);
                    return [2 /*return*/];
            }
        });
    }); };
    // Parse Cart.js API response
    var handleMakeFormatArray = function (cartProducts) {
        var _a, _b, _c;
        var formattedOutput = [];
        var newSelectedVariants = [];
        var DraftOrderDetailsFromRedux = (_c = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.editDraftOrder) === null || _b === void 0 ? void 0 : _b.productDetailsArray) !== null && _c !== void 0 ? _c : [];
        var variantDictionary = Object.fromEntries(DraftOrderDetailsFromRedux.filter(function (item) { return !!item.variantId; }).map(function (item) { return [item.variantId, item]; }));
        cartProducts === null || cartProducts === void 0 ? void 0 : cartProducts.forEach(function (inputObject) {
            var _a, _b, _c, _d;
            var existingProductIndex = formattedOutput.findIndex(function (product) { return product.productId === "gid://shopify/Product/" + inputObject.product_id; });
            var inventoryQuantity = (_b = (_a = variantDictionary[inputObject.variant_id]) === null || _a === void 0 ? void 0 : _a.inventoryQuantity.toString()) !== null && _b !== void 0 ? _b : "NA";
            var formattedVariant = {
                variantId: "gid://shopify/ProductVariant/" + inputObject.variant_id,
                variantPrice: inputObject.final_price / 100,
                imageUrl: ((_c = inputObject.featured_image) === null || _c === void 0 ? void 0 : _c.url) || "",
                currency: shopCurrency,
                inventoryQuantity: inputObject.quantity,
                sku: inputObject.sku,
                title: inputObject.variant_title || "Default Title",
                quantityAvailable: inventoryQuantity !== null && inventoryQuantity !== void 0 ? inventoryQuantity : "NA",
                availableForSale: true,
                quantity: inputObject.quantity,
                wholesalePrice: inputObject.final_price / 100,
            };
            if (existingProductIndex !== -1) {
                // If the product already exists, add the variant to its variants array
                formattedOutput[existingProductIndex].variants.push(formattedVariant);
            }
            else {
                // If the product doesn't exist, create a new product and add it to the formattedOutput
                var productModel = {
                    productId: "gid://shopify/Product/" + inputObject.product_id,
                    title: inputObject.title,
                    variants: [formattedVariant],
                    imageUrl: ((_d = inputObject.featured_image) === null || _d === void 0 ? void 0 : _d.url) || null,
                };
                formattedOutput.push(productModel);
            }
            newSelectedVariants.push(formattedVariant);
        });
        // Update selectedVariantArray state with all new variants
        setSelectedVariantArray(function (prevSelectedVariantObject) { return __spreadArray(__spreadArray([], prevSelectedVariantObject, true), newSelectedVariants, true); });
        setSelectedProductArray(formattedOutput);
        // Update net quantity subtotal for all variants
        newSelectedVariants === null || newSelectedVariants === void 0 ? void 0 : newSelectedVariants.forEach(function (formattedVariant) {
            var _a;
            updateNetQuantitySubtotal((formattedVariant === null || formattedVariant === void 0 ? void 0 : formattedVariant.quantity) || 1, formattedVariant.variantId, (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.PriceList) && (createOrderTabReduxState === null || createOrderTabReduxState === void 0 ? void 0 : createOrderTabReduxState.customerName) !== ""
                ? wholePriceObj[Number((_a = formattedVariant.variantId) === null || _a === void 0 ? void 0 : _a.split("gid://shopify/ProductVariant/")[1])] || formattedVariant.variantPrice
                : formattedVariant.variantPrice, "manual", "isReadCartData");
        });
        return formattedOutput;
    };
    var appliedDiscount = function (e, variant) {
        var _a, _b, _c, _d, _e, _f, _g;
        var _h, _j, _k, _l, _m, _o;
        if (isCustomVariant(variant)) {
            return;
        }
        var value = e.target.value;
        var variantId = variant === null || variant === void 0 ? void 0 : variant.variantId;
        try {
            var price_1 = handleWholesalePriceMapping(variant);
            if (variantId) {
                if (value !== "") {
                    var numberValue = Number(value);
                    setDiscount_idObject(__assign(__assign({}, discount_idObject), (_a = {}, _a[variantId] = parseFloat(value), _a)));
                    if (selectedDiscountType === "percentage") {
                        if (numberValue > 0 && numberValue <= 100) {
                            var quantity = ((_h = netQuantitySubtotal[variantId]) === null || _h === void 0 ? void 0 : _h.quantity) || 1;
                            var unitDiscountedPrice = parseFloat((_j = (price_1 - (price_1 * numberValue) / 100)) === null || _j === void 0 ? void 0 : _j.toFixed(2)); // Apply discount to unit price
                            var discountApplied_1 = parseFloat((_k = (unitDiscountedPrice * quantity)) === null || _k === void 0 ? void 0 : _k.toFixed(2)); // Multiply by quantity
                            setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                                var _a;
                                return (__assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variantId] = __assign(__assign({}, prevNetQuantitySubtotal[variantId]), { subtotal: discountApplied_1 }), _a)));
                            });
                            setIsDiscountError(__assign(__assign({}, isDiscountError), (_b = {}, _b[variantId] = false, _b)));
                        }
                        else {
                            setIsDiscountError(__assign(__assign({}, isDiscountError), (_c = {}, _c[variantId] = true, _c)));
                        }
                    }
                    else {
                        // Fixed Amount discount: value is per-unit discount
                        var quantity = ((_l = netQuantitySubtotal[variantId]) === null || _l === void 0 ? void 0 : _l.quantity) || 1;
                        var perUnitDiscount = parseFloat(value);
                        // Validate: discount should not exceed unit price
                        if (perUnitDiscount >= 0 && perUnitDiscount <= price_1) {
                            // Apply per-unit discount: (price - perUnitDiscount) × quantity
                            var unitDiscountedPrice = parseFloat((_m = (price_1 - perUnitDiscount)) === null || _m === void 0 ? void 0 : _m.toFixed(2));
                            var discountApplied_2 = parseFloat((_o = (unitDiscountedPrice * quantity)) === null || _o === void 0 ? void 0 : _o.toFixed(2));
                            setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                                var _a;
                                return (__assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variantId] = __assign(__assign({}, prevNetQuantitySubtotal[variantId]), { subtotal: discountApplied_2 }), _a)));
                            });
                            setIsDiscountError(__assign(__assign({}, isDiscountError), (_d = {}, _d[variantId] = false, _d)));
                        }
                        else {
                            setIsDiscountError(__assign(__assign({}, isDiscountError), (_e = {}, _e[variantId] = true, _e)));
                        }
                    }
                }
                else {
                    setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                        var _a;
                        var _b, _c;
                        return (__assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variantId] = __assign(__assign({}, prevNetQuantitySubtotal[variantId]), { quantity: netQuantitySubtotal[variantId] ? (_b = netQuantitySubtotal[variantId]) === null || _b === void 0 ? void 0 : _b.quantity : 1, subtotal: netQuantitySubtotal[variantId] ? price_1 * ((_c = netQuantitySubtotal[variantId]) === null || _c === void 0 ? void 0 : _c.quantity) : 1 }), _a)));
                    });
                    setDiscount_idObject(__assign(__assign({}, discount_idObject), (_f = {}, _f[variantId] = "", _f)));
                    setIsDiscountError(__assign(__assign({}, isDiscountError), (_g = {}, _g[variantId] = false, _g)));
                }
            }
            else {
                setAlertErrorMsg({ msg: t("customerInvoice_AlertErrorMsg"), open: true });
            }
        }
        catch (error) {
            return;
        }
    };
    var handleSelectChangeForDiscountType = function (event) {
        setPendingDiscountType(event.target.value);
        setDiscountAlertBox(true);
    };
    var handleConfirmChangeDiscountType = function () {
        setDiscountAlertBox(false);
        setSelectedDiscountType(pendingDiscountType);
        finalSelectedProducts === null || finalSelectedProducts === void 0 ? void 0 : finalSelectedProducts.forEach(function (product) {
            var _a;
            (_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.forEach(function (variant) {
                var subtotalCount = handleWholesalePriceMapping(variant);
                setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                    var _a;
                    var _b, _c;
                    return (__assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variant === null || variant === void 0 ? void 0 : variant.variantId] = __assign(__assign({}, prevNetQuantitySubtotal[variant === null || variant === void 0 ? void 0 : variant.variantId]), { quantity: netQuantitySubtotal[variant === null || variant === void 0 ? void 0 : variant.variantId] ? (_b = netQuantitySubtotal[variant === null || variant === void 0 ? void 0 : variant.variantId]) === null || _b === void 0 ? void 0 : _b.quantity : 1, subtotal: netQuantitySubtotal[variant === null || variant === void 0 ? void 0 : variant.variantId] ? subtotalCount * ((_c = netQuantitySubtotal[variant === null || variant === void 0 ? void 0 : variant.variantId]) === null || _c === void 0 ? void 0 : _c.quantity) : 1 }), _a)));
                });
            });
        });
        setDiscount_idObject({});
    };
    var handleCancelChangeDiscountType = function () {
        setDiscountAlertBox(false);
    };
    var isNotEmpty = function (params) {
        if (params !== null && params !== undefined) {
            return true;
        }
        else {
            return false;
        }
    };
    var handleAlertMsgClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setAlertErrorMsg({ msg: "", open: false });
    };
    var upsertCustomLineItem = function (draft) {
        var _a, _b;
        var id = draft.customLineItemId;
        var variantId = "".concat(CUSTOM_VARIANT_PREFIX).concat(id);
        var unitPrice = Number((_a = draft.price) !== null && _a !== void 0 ? _a : 0) || 0;
        var qty = draft.quantity > 0 ? Math.floor(draft.quantity) : 1;
        var customVariant = {
            variantId: variantId,
            variantPrice: unitPrice,
            imageUrl: "",
            currency: shopCurrency,
            inventoryQuantity: qty,
            sku: "",
            title: draft.title,
            quantityAvailable: "NA",
            availableForSale: true,
            quantity: qty,
            wholesalePrice: unitPrice,
            custom: true,
            isCustom: true,
            customLineItemId: id,
            price: ((_b = draft.price) !== null && _b !== void 0 ? _b : "0").toString(),
            name: draft.title,
            taxable: draft.taxable,
            isPhysicalProduct: draft.isPhysicalProduct,
            requires_shipping: draft.isPhysicalProduct,
            weight: draft.weight,
            weight_unit: draft.weight_unit,
        };
        var customProduct = {
            productId: "".concat(CUSTOM_VARIANT_PREFIX).concat(id),
            title: draft.title,
            imageUrl: "",
            variants: [customVariant],
        };
        setSelectedVariantArray(function (prev) {
            var exists = prev === null || prev === void 0 ? void 0 : prev.some(function (v) { return (v === null || v === void 0 ? void 0 : v.variantId) === variantId; });
            if (!exists)
                return __spreadArray(__spreadArray([], prev, true), [customVariant], false);
            return prev === null || prev === void 0 ? void 0 : prev.map(function (v) { return ((v === null || v === void 0 ? void 0 : v.variantId) === variantId ? __assign(__assign({}, v), customVariant) : v); });
        });
        setSelectedProductArray(function (prev) {
            var exists = prev === null || prev === void 0 ? void 0 : prev.some(function (p) { return (p === null || p === void 0 ? void 0 : p.productId) === customProduct.productId; });
            if (!exists)
                return __spreadArray(__spreadArray([], prev, true), [customProduct], false);
            return prev === null || prev === void 0 ? void 0 : prev.map(function (p) { return ((p === null || p === void 0 ? void 0 : p.productId) === customProduct.productId ? __assign(__assign({}, p), customProduct) : p); });
        });
        setNetQuantitySubtotal(function (prev) {
            var _a;
            var _b;
            return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = {
                quantity: qty,
                subtotal: parseFloat((_b = (qty * unitPrice)) === null || _b === void 0 ? void 0 : _b.toFixed(2)),
            }, _a)));
        });
    };
    var handleSubmitCustomItem = function (draft) {
        var _a, _b, _c, _d;
        if (!draft)
            return;
        var id = ((_a = draft.customLineItemId) !== null && _a !== void 0 ? _a : "").toString() || newCustomLineItemId();
        // Use weight and weight_unit directly (no conversion)
        var weightNum = draft.weight && draft.weight.trim() !== "" ? Number(draft.weight) : 0;
        var weight = draft.isPhysicalProduct && weightNum > 0 ? weightNum : undefined;
        var weight_unit = draft.isPhysicalProduct && weightNum > 0 ? draft.weight_unit : undefined;
        upsertCustomLineItem({
            customLineItemId: id,
            title: ((_b = draft.title) !== null && _b !== void 0 ? _b : "").toString(),
            price: ((_c = draft.price) !== null && _c !== void 0 ? _c : "0").toString(),
            quantity: Math.max(1, Number((_d = draft.quantity) !== null && _d !== void 0 ? _d : 1) || 1),
            taxable: draft.taxable,
            isPhysicalProduct: !!draft.isPhysicalProduct,
            weight: weight,
            weight_unit: weight_unit,
        });
        setCustomItemModalOpen(false);
    };
    return {
        totalOrderAmount: totalOrderAmount,
        masterSubTotal: masterSubTotal,
        handleSearchProductData: handleSearchProductData,
        makeFieldsEmpty: makeFieldsEmpty,
        productSearchText: productSearchText,
        handleKeyDown: handleKeyDown,
        handleProductTableSearchPopup: handleProductTableSearchPopup,
        shopCurrency: shopCurrency,
        handleSearchTextChange: handleSearchTextChange,
        searchTablePopupOpen: searchTablePopupOpen,
        productsArray: productsArray,
        getProductsLoading: getProductsLoading,
        selectedProductArray: selectedProductArray,
        checkUncheckProductVariant: checkUncheckProductVariant,
        selectedVariantArray: selectedVariantArray,
        selectedProductIdArray: selectedProductIdArray,
        showSelectedProduct: showSelectedProduct,
        netQuantitySubtotal: netQuantitySubtotal,
        updateNetQuantitySubtotal: updateNetQuantitySubtotal,
        finalSelectedProducts: finalSelectedProducts,
        closePopupForSearchProductData: closePopupForSearchProductData,
        removeAllSelectedProducts: removeAllSelectedProducts,
        handleNextClick: handleNextClick,
        handlePrevClick: handlePrevClick,
        pageInfo: pageInfo,
        readCartProducts: readCartProducts,
        salesRepData: salesRepData,
        selectFeatures: selectFeatures,
        createOrderTabReduxState: createOrderTabReduxState,
        handleWholesalePriceMapping: handleWholesalePriceMapping,
        hideWholeSalePriceListColumn: hideWholeSalePriceListColumn,
        handleAlertMsgClose: handleAlertMsgClose,
        alertErrorMsg: alertErrorMsg,
        isQuantityError: isQuantityError,
        t: t,
        isNotEmpty: isNotEmpty,
        propsFromCreateOrderParentTab: propsFromCreateOrderParentTab,
        appliedDiscount: appliedDiscount,
        getDisplayDiscountValue: getDisplayDiscountValue,
        isDiscountError: isDiscountError,
        discount_idObject: discount_idObject,
        selectedDiscountType: selectedDiscountType,
        orderLevelDiscountType: selectedDiscountType,
        handleSelectChangeForDiscountType: handleSelectChangeForDiscountType,
        handleDiscountAmountChange: handleDiscountAmountChange,
        ShopApplyDiscount: ShopApplyDiscount,
        handleConfirmChangeDiscountType: handleConfirmChangeDiscountType,
        handleCancelChangeDiscountType: handleCancelChangeDiscountType,
        discountAlertBox: discountAlertBox,
        isDiscoutAppliedInEditDraft: isDiscoutAppliedInEditDraft,
        tableContainerRef: tableContainerRef,
        isDiscountAppliedInInline: isDiscountAppliedInInline,
        isRemoveCartPopup: isRemoveCartPopup,
        setIsRemoveCartPopup: setIsRemoveCartPopup,
        hoveredIconIndex: hoveredIconIndex,
        setHoveredIconIndex: setHoveredIconIndex,
        loadMoreProducts: loadMoreProducts,
        getLineDiscountLabel: getLineDiscountLabel,
        currency: currency,
        upsertCustomLineItem: upsertCustomLineItem,
        customItemModalOpen: customItemModalOpen,
        customItemModalMode: customItemModalMode,
        customItemInitial: customItemInitial,
        openAddCustomItemModal: openAddCustomItemModal,
        openEditCustomItemModal: openEditCustomItemModal,
        closeCustomItemModal: closeCustomItemModal,
        handleSubmitCustomItem: handleSubmitCustomItem,
    };
}
export function cssConstants() {
    var QuantityBtns = {
        background: "#F2F2F2",
        border: "1px solid #E0E0E0",
        color: "gray",
        minWidth: "40px !important",
    };
    var ST_CI_TotalPriceRenderBox = {
        display: "flex",
        alignItems: "center",
        border: 1,
        borderRadius: 1,
        borderColor: "#d4d4d4",
        backgroundColor: "white",
        mt: 1,
        color: "black",
        "& svg": { m: 1.5 },
        "& hr": { borderColor: "black", borderWidth: 1, background: "black" },
        width: 280,
        height: 40,
    };
    var inputFieldQty = { width: "50px", m: "5px", textAlign: "center" };
    var inputFieldDiscount = { width: "90px", m: "5px", textAlign: "center" };
    return {
        QuantityBtns: QuantityBtns,
        inputFieldQty: inputFieldQty,
        ST_CI_TotalPriceRenderBox: ST_CI_TotalPriceRenderBox,
        inputFieldDiscount: inputFieldDiscount,
    };
}
